import { Component, OnInit } from '@angular/core';
import { TravelService } from 'src/app/services/travel.service';
import { ActivatedRoute } from '@angular/router';
import { Travel } from 'src/app/models/travel';
import { AuthService } from 'src/app/services/auth.service';
import { ExpenseService } from 'src/app/services/expense.service';
import { Expense } from 'src/app/models/expense';
import { TravelLine } from 'src/app/models/travel-line';
import { TravelExpense } from 'src/app/models/travel-expense';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TravelManager } from 'src/app/classes/travel-manager';
import { UnityService } from 'src/app/services/unity.service';
import { Set } from 'src/app/models/set';
import { Unity } from 'src/app/models/unity';
import { DriverService } from 'src/app/services/driver.service';
import { Driver } from 'src/app/models/driver';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { ToastrManager } from 'ng6-toastr-notifications';
import { LogisticEventsService } from 'src/app/services/logistic-events.service';
import { TravelLineTicket } from 'src/app/models/travel-line-ticket';
import { SapService } from 'src/app/services/sap.service';

@Component({
  selector: 'app-travel-single',
  templateUrl: './travel-single.component.html',
  styleUrls: ['./travel-single.component.css']
})
export class TravelSingleComponent implements OnInit {

  travel:Travel = new Travel();
  travelLine:TravelLine;
  loading:boolean = false;
  canClose:boolean = false;
  canDelete:boolean = false;
  canUpdate:boolean = false;
  canUpdate2:boolean = false;
  canUpdateInvoice:boolean = false;
  gas_price:number = 0;
  casetas:Expense[] = [];
  combustibles:Expense[] = [];
  caseta:Expense;
  combustible:Expense;
  tickets:TravelLineTicket[] = [];
  ticketsList:TravelLineTicket[] = [];
  ticket:TravelLineTicket = new TravelLineTicket();

  showInput:boolean = false;
  showText:boolean = false;

  sets:Set[] = [];
  set:Set;
  unities:Unity[] = [];
  drivers:Driver[] = [];
  quantity:number = 0;
  //Tipo de sociedades donde se puede obtener el ticket
  travelSocieties = [ {id: 'NMH_PROD', name: 'NMH'}, {id: 'PROECO_PROD', name: 'PROECO'}, {id: 'CELFOS_PROD', name: 'CELFOS'}, {id: 'HIFOS_PROD', name: 'HIFOS'} ];
  societyTicket: string = 'NMH_PROD';
  units:Unity[];
  arrastre1:Unity[];
  arrastre2:Unity[];
  arrastre3:Unity[];
  arrastre3B:Unity[];
  truckDisabled = true;
  arrastre1Disabled = true;
  arrastre2Disabled = true;
  arrastre3Disabled = true;

  delivery_date: Date = new Date();

  dateErrorMsg = '';
  showError = false;
  temp_tipo_date = '';

  constructor(private travelServ:TravelService, actRoute:ActivatedRoute, private auth:AuthService, private expServ:ExpenseService, private modalService: NgbModal, private travelManager:TravelManager, private unityServ:UnityService, private driverServ:DriverService, private utl:UtilitiesService, private toastr: ToastrManager, private logisticEv:LogisticEventsService, private sapServ:SapService) { 
    actRoute.params.subscribe(params => {
      this.loadTravel(params.id);
      
    });
  }

  loadTravel(id){
    this.loading = true;
    this.travelServ.getTravel(id).then(tr => {
      this.travel = tr;

      this.set = {
        contracted: this.travel.contracted,
        helper_1: this.travel.helper_1,
        helper_1_id: this.travel.helper_1_id,
        helper_2: this.travel.helper_2,
        helper_2_id: this.travel.helper_2_id,
        id: this.travel.set_id,
        operator: this.travel.operator,
        operator_id: this.travel.operator_id,
        trailer_1: this.travel.trailer_1,
        trailer_1_id: this.travel.trailer_1_id,
        trailer_2: this.travel.trailer_2,
        trailer_2_id: this.travel.trailer_2_id,
        trailer_3: this.travel.trailer_3,
        trailer_3_id: this.travel.trailer_3_id,
        truck: this.travel.unity,
        truck_id: this.travel.unity_id,
      };

      this.loading = false;

      if (this.travel.status == 'Entregado' || this.travel.status == 'Viaje Creado') {
        this.expServ.getExpenses("type", "Viaje").then(expenses => {
          this.casetas = expenses.filter(expense => expense.expense_type.name == 'Casetas');
          this.combustibles = expenses.filter(expense => expense.expense_type.name == 'Combustible');
        });
      }

      this.travel.delivery_date = new Date(this.travel.delivery_date);
      this.travel.prd_loading_date = new Date(this.travel.prd_loading_date);
      this.travel.gas_loading_date = new Date(this.travel.gas_loading_date);

      this.canClose = this.auth.can('store-travel');
      this.canUpdate = this.auth.can('update-travel') && this.travel.status == 'Viaje Creado';
      this.canUpdate2 = this.auth.can('update-travel') && this.travel.status == 'Cerrado';
      this.canDelete = this.auth.can('destroy-travel');
      this.canUpdateInvoice = this.auth.can('update-travel-invoice');

      this.showInput = (this.travel.status == 'Entregado' || this.travel.status == 'Viaje Creado') && this.canClose;
      this.showText = (this.travel.status != 'Entregado' && this.travel.status != 'Viaje Creado') || !this.canClose;
    });
  }
  update(tipo_date:string) {
    this.loading = true;
    switch (tipo_date) {
      case 'delivery_date':
        this.travelServ.setDeliveryDate(this.travel.id, this.travel.delivery_date).then(r => {
          location.reload();
        });
      break;
      case 'prd_loading_date':
        this.travelServ.setPrdLoadDate(this.travel.id, this.travel.prd_loading_date).then(r => {
          location.reload();
        });
      break;
      case 'gas_loading_date':
        this.travelServ.setGasLoadDate(this.travel.id, this.travel.gas_loading_date).then(r => {
          location.reload();
        });
      break;
    }
  }
  
  handleSubmit(tipo_date:string, modal:any) {
    this.checkDates();
    if (this.showError) {
      this.temp_tipo_date = tipo_date;
      this.openModal(modal); 
    } else {
      this.update(tipo_date);
    }
  }
  updatedate(modal:any) {
    modal.close();
    this.update(this.temp_tipo_date);
  }
  setDate(date: any){
    if (date instanceof Date) {
      return new Date(date.getFullYear(), date.getMonth(), date.getDate());
    }
    if (typeof date === 'string') {
      const [year, month, day] = date.split('-').map(Number);
      return new Date(year, month - 1, day);
    }
    return null;
  };
  checkDates(){
    const delivery = this.setDate(this.travel.delivery_date);
    const prd = this.setDate(this.travel.prd_loading_date);
    const gas = this.setDate(this.travel.gas_loading_date);

    this.dateErrorMsg = '';

    if (gas==null || prd==null || delivery==null) {
      this.dateErrorMsg = 'Las fechas de carga de combustible, carga de producto y entrega son obligatorias';
    }else{
      // if (gas > delivery) this.dateErrorMsg = 'Fecha de carga de combustible no debe ser después de fecha de Entrega';
      if (gas > prd) this.dateErrorMsg = 'Fecha de carga de combustible no debe ser después de fecha de Producto';
      if (prd > delivery) this.dateErrorMsg = 'Fecha de carga de producto no debe ser después de fecha de Entrega';
    }

    if(this.dateErrorMsg != '') this.showError = true;
    else this.showError = false;

  }
  ngOnInit() {
    this.unityServ.getSets().then(sets => this.sets = sets);
    this.unityServ.getUnities().then(unities => {
      this.setArrastres(unities);
      this.unities = unities;
    });
    this.driverServ.getDrivers(true).then(drivers => this.drivers = drivers);
  }

  setUnities() {
    const checkarrastres = this.verifArrastres();
    if (checkarrastres[0]) {
      this.toastr.errorToastr(checkarrastres[1], 'Oops!', { enableHTML: true });
      return;
    }
    if (this.travel.contracted == this.set.contracted) {
      this.loading = true;
      this.travelServ.setUnities(this.travel.id, this.set).then(tr => {
        this.travel = tr;
        this.travel.delivery_date = new Date(this.travel.delivery_date);
        this.toastr.successToastr('El viaje ' + this.travel.id + ' fue actualizado correctamente', '', { enableHTML: true });
  
        location.reload();
      }).catch(e => {
        if (e.status == 422) {
          this.toastr.errorToastr(this.utl.formatMessages(e), '', { enableHTML: true });
        } else if (e.status == 400) {
          this.toastr.errorToastr(e.error.message);
        } else {
          this.toastr.errorToastr('Ocurrió un error inesperado. Intente nuevamente o contacte con soporte', '', { enableHTML: true });
        }
        this.loading = false;
      });
    } else {
      this.toastr.infoToastr("No puedes cambiar una unidad de un" + (this.travel.contracted ? "" : " No") + " Contratado a un" + (this.set.contracted ? "" : " No") + " Contratado");
    }
  }

  selectline(modal, ln:TravelLine) {
    this.travelLine = ln;
    this.modalService.open(modal, { size: 'lg' });
  }

  deleteTravel() {
    this.loading = true;
    this.travelServ.deleteTravel(this.travel).then(resp => {
      this.logisticEv.sendTravelDeleted(this.travel);
      location.reload();
      this.toastr.successToastr("Viaje eliminado correctamente!");
    });
  }

  closeTravel() {
    for (let i = 0; i < this.travel.expenses.length; i++) {
      let exp = this.travel.expenses[i];
      if ((exp.price == 0 || exp.quantity == 0) && exp.active) {
        this.toastr.infoToastr("No se puede cerrar un viaje con gastos en cantidades en cero");
        return;
      }
    }

    this.loading = true;
    let lines = this.travel.lines.map(line => {
      return {
        gas_extra: line.gas_extra,
        tickets: this.tickets,
        ton_real: line.ton_real,
        num_lines: line.num_lines,
        id: line.id,
        expenses: this.travel.expenses.filter(expense => expense.travel_line_id == line.id)
      }
    });

    this.travelServ.closeTravel(this.travel.id, {
      lines,
      gas_price: this.gas_price,
      description: this.travel.description,
    }).then(resp => {
      this.travelServ.getTravel(this.travel.id).then(travel => {
        this.travel = travel;
        location.reload();
        this.toastr.successToastr("Viaje actualizado correctamente!");

        this.showInput = (this.travel.status == 'Entregado' || this.travel.status == 'Viaje Creado') && this.canClose;
        this.showText = (this.travel.status != 'Entregado' && this.travel.status != 'Viaje Creado') || !this.canClose;
        this.canUpdate = this.auth.can('update-travel') && this.travel.status == 'Viaje Creado';
      })
    }).catch(resp => {
      this.loading = false;
      this.toastr.errorToastr("Error desconocido");
    });
  }

  removeExpense(exp:TravelExpense) {
    if (exp.first) {
      exp.active = !exp.active;
    } else {
      this.travel.expenses = this.travel.expenses.filter(exp1 => exp != exp1);
    }
  }

  addExpense() {
    let axis:number = this.travelManager.getAxis(this.travel.unity, this.travel.trailer_1, this.travel.trailer_2, this.travel.trailer_3);

    let exp = this.caseta.axis.find(exp => exp.axis == axis);

    /*if (!exp) {
      this.toastr.infoToastr("Expense has not a price for " + axis + " axis");
      return;
    }*/

    for(let i = 0; i < this.travel.expenses.length; i++) {
      if (this.travel.expenses[i].expense_id == this.caseta.id && this.travel.expenses[i].travel_id == this.travelLine.id) {
        this.toastr.infoToastr("El gasto ya existe!");
        return;
      }
    }

    this.travel.expenses.push({
      active: true,
      axis: axis,
      expense_id: this.caseta.id,
      expense_name: this.caseta.name,
      first: false,
      price: exp ? exp.price : 0,
      quantity: 1,
      travel_id: this.travel.id,
      travel_line_id: this.travelLine.id,
      expense_type: this.caseta.expense_type.type,
      expense_type_name: this.caseta.expense_type.name,
      expense_type_id: this.caseta.expense_type.id,
      automatic: false,
    });
  }

  addComb() {
    for(let i = 0; i < this.travel.expenses.length; i++) {
      if (this.travel.expenses[i].expense_id == this.combustible.id && this.travel.expenses[i].travel_id == this.travelLine.id) {
        this.toastr.infoToastr("El gasto ya existe!");
        return;
      }
    }

    this.travel.expenses.push({
      active: true,
      axis: 1,
      expense_id: this.combustible.id,
      expense_name: this.combustible.name,
      first: false,
      price: this.combustible.price,
      quantity: 1,
      travel_id: this.travel.id,
      travel_line_id: this.travelLine.id,
      expense_type: this.combustible.expense_type.type,
      expense_type_name: this.combustible.expense_type.name,
      expense_type_id: this.combustible.expense_type.id,
      automatic: false,
    });
  }

  openModal(modal) {
    this.modalService.open(modal, {size: 'lg'});
  }

  selectSet(set:Set) { 
    this.set = set;
  }

  saveTicket2() {
    this.travelServ.postGasTicket2(this.travel.id, this.quantity).then(res => {
      this.toastr.successToastr('Viaje Actualizado Correctamente');
      this.travel.gas_ticket_2 = res;

      window.open("/travel/gasticket2/" + this.travel.id, "_blank");
    });
  }

  open () {
    this.travelServ.openTravel(this.travel.id).then(resp => location.reload());
  }

  updateInvoice() {
    this.loading = true;
    this.travelServ.setInvoice(this.travel, this.travel.invoice)
      .then(resp => this.loading = false);
  }

  showData = true;
  searchTicket() {
    if(this.ticket.ticket_number)
    {
      if(this.societyTicket)
      {
        let ticket = this.ticket.ticket_number;
        let society = this.societyTicket;
        this.loading = true;
        this.sapServ.getTickets(ticket, society).then(resp => {
        this.loading = false;
        this.ticketsList = resp;
        if (this.ticketsList.length) {
          this.ticket = this.ticketsList[0];
          this.selectTicket();
        }
        }).catch(resp => {
          this.loading = false;
          this.toastr.errorToastr(this.utl.formatMessages(resp), '', {enableHTML: true});
        });
      }else{ this.toastr.infoToastr('Debe especificar la sociedad donde se encuentra el ticket a buscar', '', {enableHTML: true}); }
    }else{ this.toastr.infoToastr('El no. de ticket es necesario', '', {enableHTML: true}); }
  }

  selectTicket() {
    if (this.ticket.ticket_number) {
      this.ticket.travel_line_id = this.travel_line_id;
      this.showData = false;
    } else {
      this.ticket.tara = 0;
      this.ticket.tara_date = '';
      this.ticket.tara_hour = '';
      this.ticket.bruto = 0;
      this.ticket.bruto_date = '';
      this.ticket.bruto_hour = '';
      this.showData = true;
      this.toastr.errorToastr('No se encontrarón datos de ticket');
    }
  }

  addTicket() {
    this.ticket.travel_line_id = this.travel_line_id;
    this.ticket.neto = 0;
    if(this.ticket.tara && this.ticket.tara_date && this.ticket.tara_hour && this.ticket.bruto && this.ticket.bruto_date && this.ticket.bruto_hour) {
      this.loading = true;
      this.travelServ.postTiketLine(this.ticket).then(resp => {
          this.loading = false;
          this.ticket.tara = 0;
          this.ticket.tara_date = '';
          this.ticket.tara_hour = '';
          this.ticket.bruto = 0;
          this.ticket.bruto_date = '';
          this.ticket.bruto_hour = '';
          this.ticket.ticket_number = '';
          this.tickets.push(resp);
        }).catch(resp => {
          this.loading = false;
          this.toastr.errorToastr(this.utl.formatMessages(resp), '', {enableHTML: true});
        });
    }else{
      this.toastr.errorToastr('Todos los datos son obligatorios', '', {enableHTML: true});
    }
  }

  deleteTicket(ticket){
    this.loading = true;
    this.travelServ.deleteTicket(ticket).subscribe(resp => {
      this.tickets = this.tickets.filter(tick => tick.id != ticket.id);
      this.loading = false;
      this.toastr.successToastr(resp.message, '', {enableHTML: true});
    }, error =>{
      this.loading = false;
      this.toastr.errorToastr(this.utl.formatMessages(error), '', {enableHTML: true});
    });
  }

  travel_line_id = 0;
  openModalTicket(modal, id) {
    this.travel_line_id = id; 
    this.loading = true;
    this.travelServ.getTiketLine(id)
      .then(resp => {
        this.loading = false;
        this.tickets = resp;
      }).catch(resp => {
        this.loading = false;
        this.toastr.errorToastr('Error fatal!');
      });
    this.openModal(modal); 
  }

  setArrastres(unities){
    const validunit = [1,7,8,9,10,11,12,15,20];
    const allowedT1 = [3,4,2,7,6,5,23,24,25];
    const doubleAllowed = [2,5,7];

    this.units = unities.filter(item => 
      validunit.includes(item.unit_type_id) 
    );
    if (this.units.find(x => x.id === this.set.truck_id)) {
      this.truckDisabled = false;
    }else{
      this.units.push(this.set.truck);
    }
    this.arrastre1= unities.filter(item => 
      allowedT1.includes(item.unit_type_id) 
    );
    this.arrastre2 = unities.filter(item => 
      item.unit_type_id === 11
    );
    this.arrastre3 = unities.filter(item => 
      doubleAllowed.includes(item.unit_type_id) 
    );
    this.arrastre3B = this.arrastre3; 
    this.setArrastresDisponibles();
  }
  setArrastresDisponibles(){
    this.setArrastresIds();
    const doubleAllowed = [2,5,7];
    this.arrastre1Disabled = !(this.set.truck && this.set.truck.unit_type_id == 1);
    if (this.arrastre1Disabled) {
      this.set.trailer_1 = null;
      this.set.trailer_1_id = null;
    }

    if(this.set.trailer_1 && doubleAllowed.includes(this.set.trailer_1.unit_type_id)){
      this.arrastre2Disabled = false;
      this.arrastre3 = this.arrastre3B.filter(item => 
        this.set.trailer_1.unit_type_id === item.unit_type_id 
        && this.set.trailer_1.id !== item.id
      );

      if(this.set.trailer_3 && !this.arrastre3.some(item => item.id === this.set.trailer_3.id)){
        this.set.trailer_3 = null;
        this.set.trailer_3_id = null;
      }
    }else{
      this.arrastre2Disabled = true;
      this.arrastre3Disabled = true;
      this.set.trailer_2 = null;
      this.set.trailer_3 = null;
      this.set.trailer_2_id = null;
      this.set.trailer_3_id = null;
      return;
    }
    this.arrastre3Disabled = !this.set.trailer_2;
    if(this.arrastre3Disabled){
      this.set.trailer_3 = null;
      this.set.trailer_3_id = null;
    }
  }
  // setArrastresDisponibles(){
  //   this.setArrastresIds();
  //   const doubleAllowed = [2,5,7];
  //   if(this.set.truck){
  //     if (this.set.truck.unit_type_id == 1) {
  //       this.arrastre1Disabled = false; 
  //     }else{
  //       this.set.trailer_1 = null;
  //       this.set.trailer_1_id = null;
  //       this.arrastre1Disabled = true; 
  //     }
  //   }
  //   if(this.set.trailer_1){
  //     if(doubleAllowed.includes(this.set.trailer_1.unit_type_id)){
  //       this.arrastre2Disabled = false;
  //       this.arrastre3 = this.arrastre3B.filter(item => 
  //         this.set.trailer_1.unit_type_id === item.unit_type_id 
  //         && this.set.trailer_1_id !== item.id 
  //       );
  //       if(this.set.trailer_3)
  //         if(!this.arrastre3.some(item => item.id == this.set.trailer_3_id)){
  //           this.set.trailer_3 = null;
  //           this.set.trailer_3_id = null;
  //         }
  //     }else{
  //       this.arrastre2Disabled = true;
  //       this.set.trailer_2 = null;
  //       this.set.trailer_3 = null;
  //       this.set.trailer_2_id = null;
  //       this.set.trailer_3_id = null;
  //     }
  //   } else{
  //     this.arrastre2Disabled = true;
  //     this.arrastre3Disabled = true;
  //     this.set.trailer_2 = null;
  //     this.set.trailer_3 = null;
  //     this.set.trailer_2_id = null;
  //     this.set.trailer_3_id = null;
  //   } 
  //   if(this.set.trailer_2){
  //     this.arrastre3Disabled = false;
  //   }else{
  //     this.arrastre3Disabled = true;
  //     this.set.trailer_3 = null;
  //     this.set.trailer_3_id = null;
  //   }
  // }
  setArrastresIds(){
    this.set.truck     = this.getById(this.units, this.set.truck_id);
    this.set.trailer_1 = this.getById(this.arrastre1, this.set.trailer_1_id);
    this.set.trailer_2 = this.getById(this.arrastre2, this.set.trailer_2_id);
    this.set.trailer_3 = this.getById(this.arrastre3, this.set.trailer_3_id);

    if (!this.set.truck)     this.set.truck_id = null;
    if (!this.set.trailer_1) this.set.trailer_1_id = null;
    if (!this.set.trailer_2) this.set.trailer_2_id = null;
    if (!this.set.trailer_3) this.set.trailer_3_id = null;
  }
  getById(list: any[], id: any) {
    const numId = id ? Number(id) : null;
    return numId 
      ? list.find(x => x.id === numId) || null 
      : null;
  }
  verifArrastres():[boolean, string]{
    const t2 = this.set.trailer_2 ? this.set.trailer_2 : null; 
    const t3 = this.set.trailer_3 ? this.set.trailer_3 : null; 

    if (t2) {
      if (!t3) 
        return [true, 'Debe haber arrastre 3'];
    }
    return [false,''];
  }


}//FIN DE LA CLASE
